define('views/pages/multi-account/navbar',['require','underscore','views/base/view','lib/utils','helpers/application','models/base/modal','views/base/modal','text!templates/pages/multi-account/navbar.ejs','datepicker'],function(require) {
    'use strict';

    var     _ = require('underscore'),
        View = require('views/base/view'),
        utils = require('lib/utils'),
        applicationHelper =require('helpers/application'),
        ModalModel = require('models/base/modal'),
        ModalView = require('views/base/modal'),
        template = require('text!templates/pages/multi-account/navbar.ejs');

    require('datepicker');


    var NavbarView = View.extend({
        autoRender: true,
        template: template,
        tagName: 'div',
        className: 'accounts-navbar navbar',
        region: 'accounts-navbar',
        listen: {
            'change:fromDate model': 'fromDateChange',
            'change:toDate model': 'toDateChange'
        },
        events: {
            'click #operationTransfer': 'operationTransfer',
            'input .search-query': 'searchChanged',
            'propertychange .search-query': 'searchChanged',
        },

        constructor: function() {
            this.searchChanged = _.debounce(this.searchChanged, 200);
            View.apply(this, arguments);
        },

        searchChanged: function(el) {
            this.model.set('search', $(el.currentTarget).val());
        },

        operationTransfer: function() {
            this.model.trigger('operationTransfer');
        },

        updateReportUrl: function () {
            this.$('#report-multi-account-balance').attr(
                'href',
                applicationHelper.apiUrl('/report/xlsx/multi-account-balance', {
                    fromDate: applicationHelper.fmtDate(this.model.get('params').get('fromDate')),
                    toDate:   applicationHelper.fmtDate(this.model.get('params').get('toDate'))
                })
            );
        },

        setupDatePickers: function() {
            var model = this.model;

            var _this = this;

            var $fd = this.$('#fromDate');
            var $td = this.$('#toDate');

            var fromDate = this.fromDate = $fd
                .datepicker({
                })
                .on('changeDate', function(ev) {
                    fromDate.hide();
                    model.get('params').set('fromDate', ev.date);

                    _this.updateReportUrl();
                })
                .on('show', function() {
                    if (model.get('loading')) {
                        fromDate.hide();
                    }
                })
                .data('datepicker');
            // fromDate.setValue(utils.fmtDate(model.get('fromDate')));

            var toDate = this.toDate = $td
                .datepicker({
                })
                .on('changeDate', function(ev) {
                    toDate.hide();
                    model.get('params').set('toDate', ev.date);

                    _this.updateReportUrl();
                })
                .on('show', function() {
                    if (model.get('loading')) {
                        toDate.hide();
                    }
                })
                .data('datepicker');
            // toDate.setValue(utils.fmtDate(model.get('toDate')));
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            this.setupDatePickers();
        },
        fromDateChange: function(model, date) {
            if (date.valueOf() > model.get('params').get('toDate').valueOf()) {
                var newDate = new Date(date);
                newDate.setDate(newDate.getDate() + 1);
                model.get('params').set('toDate', newDate);
            }

            if (this.fromDate) {
                this.fromDate.setValue(date);
                this.fromDate.update(date);
            }
        },
        toDateChange: function(model, date) {
            if (date.valueOf() < model.get('params').get('fromDate').valueOf()) {
                var newDate = new Date(date);
                newDate.setDate(newDate.getDate() - 1);
                model.get('params').set('fromDate', newDate);
            }

            if (this.toDate) {
                this.toDate.setValue(date);
                this.toDate.update(date);
            }
        }
    });

    return NavbarView;
});

